// Logotipo HarpIA — marca + wordmark. SEM italic em qualquer elemento.
// "IA" usa Geist regular (fontWeight 400), NAO Instrument Serif, NAO italic.
import harpiaLogo from "@/assets/brand/harpia-logo.jpeg";

export interface HarpIALogoProps {
  size?: number;
  color?: string;
  showWordmark?: boolean;
  gap?: number;
}

export function HarpIALogo({
  size = 22,
  color = "currentColor",
  showWordmark = true,
  gap = 8,
}: HarpIALogoProps) {
  const markSize = size + 4;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap,
        color,
        fontStyle: "normal",
      }}
    >
      <img
        src={harpiaLogo}
        alt=""
        aria-hidden="true"
        width={markSize}
        height={markSize}
        style={{
          width: markSize,
          height: markSize,
          objectFit: "contain",
          display: "block",
          flexShrink: 0,
        }}
      />
      {showWordmark && (
        <span
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 600,
            fontStyle: "normal",
            letterSpacing: "-0.02em",
            fontSize: size,
            lineHeight: 1,
            color,
          }}
        >
          Harp
          <span
            style={{
              fontWeight: 400,
              fontStyle: "normal",
              fontFamily: "var(--font-display)",
            }}
          >
            IA
          </span>
        </span>
      )}
    </span>
  );
}
